import { Link, useLocation } from "react-router-dom";
import { FaHome, FaUsers, FaUserAlt, FaTimes, FaBlog, FaTag } from "react-icons/fa";
import { Divider } from "@mui/material";
import "./Sidebar.css";
import logo from "../Assets/BooksCompl.png";

const AdminSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation(); // Get current route

  return (
    <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
      {/* Close Button (Mobile Only) */}
      <button className="close-btn" onClick={() => setSidebarOpen(false)}>
        <FaTimes />
      </button>

      <div className="logo-container">
        <img src={logo} alt="Logo" className="sidebar-logo" />
      </div>

      <Divider sx={{ bgcolor: "white", my: 2 }} />

      <ul className="nav-links">
        <li className={location.pathname === "/dashboard" ? "active" : ""}>
          <Link to="/dashboard"><FaHome /> Dashboard</Link>
        </li>
        <li className={location.pathname === "/client" ? "active" : ""}>
          <Link to="/client"><FaUserAlt /> Client</Link>
        </li>
        <li className={location.pathname === "/employee" ? "active" : ""}>
          <Link to="/employee"><FaUsers /> Employee</Link>
        </li>
        <li className={location.pathname === "/blogs" ? "active" : ""}>
          <Link to="/blogs"><FaBlog /> Blogs</Link>
        </li>

        <li className={location.pathname === "/questions" ? "active" : ""}>
          <Link to="/questions"><FaBlog /> Questions</Link>
        </li>

         <li className={location.pathname === "/admin/payments" ? "active" : ""}>
          <Link to="/admin/payments"><FaBlog /> Payment Reports</Link>
        </li>
        {/* <li className={location.pathname === "/help" ? "active" : ""}>
          <Link to="/help"><FaQuestionCircle /> Help Center</Link>
        </li> */}
      </ul>
    </aside>
  );
};

export default AdminSidebar;

